<!-- Desktop/Tablet Card -->
<ion-card
  *ngIf="platform !== platformEnumRef.mobile"
  data-cy="food-cost-card"
  (click)="onCardClick($event, foodCostReport)"
>
  <div class="value-container" data-cy="food-cost-card-container">
    <p class="date-range" data-cy="date-range">
      {{ foodCostReport?.startPeriod | date: 'M/d/yyyy' }} -
      {{ foodCostReport?.endPeriod | date: 'M/d/yyyy' }}
    </p>

    <p class="created-date" data-cy="created-date">
      {{ foodCostReport?.r4AddDtm | date: "M/d/yyyy 'at' h:mm a" }}
    </p>

    <p class="food-cost-percentage" data-cy="food-cost-percentage">
      {{ foodCostReport?.foodCostPercentage }}%
    </p>

    <app-food-cost-target
      data-cy="food-cost-target-component"
      [foodCostTarget]="foodCostReport?.target"
    ></app-food-cost-target>

    <ion-icon
      name="ellipsis-vertical"
      size="small"
      slot="end"
      data-cy="ellipsis"
      (click)="onEllipsisClick($event, foodCostReport)"
    ></ion-icon>
  </div>
</ion-card>

<!-- Mobile Card -->
<ion-card
  class="mobile-card"
  *ngIf="platform === platformEnumRef.mobile"
  data-cy="food-cost-card"
  (click)="onCardClick($event, foodCostReport)"
>
  <div class="mobile-container" data-cy="food-cost-card-container">
    <div class="left-column" data-cy="left-column">
      <p class="date-range" data-cy="date-range">
        {{ foodCostReport?.startPeriod | date: 'M/d/yyyy' }} -
        {{ foodCostReport?.endPeriod | date: 'M/d/yyyy' }}
      </p>
      <p class="created-date medium" data-cy="created-date">
        {{ foodCostReport?.r4AddDtm | date: "M/d/yyyy 'at' h:mm a" }}
      </p>
      <app-food-cost-target
        data-cy="food-cost-target-component"
        [foodCostTarget]="foodCostReport?.target"
      ></app-food-cost-target>
    </div>
    <div class="right-column" data-cy="right-column">
      <p class="food-cost-percentage" data-cy="food-cost-percentage">
        {{ foodCostReport?.foodCostPercentage }}%
      </p>
    </div>
    <ion-icon
      name="ellipsis-vertical"
      data-cy="ellipsis"
      size="small"
      slot="end"
      (click)="onEllipsisClick($event, foodCostReport)"
    ></ion-icon>
  </div>
</ion-card>
